import { Link } from 'react-router-dom';
import { aboutPrinciples } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function MissionSection() {
  const highlights = aboutPrinciples.slice(0, 3);

  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-foreground-200">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20close%20up%20of%20aged%20paper%20documents%20with%20torn%20edges%20and%20a%20red%20wax%20seal%20stamp%20on%20a%20dark%20walnut%20desk%2C%20warm%20side%20lighting%2C%20shallow%20depth%20of%20field%2C%20investigative%20archive%20mood%2C%20editorial%20still%20life%20photography&width=1000&height=750&seq=st-mission-2026&orientation=landscape"
                  alt="泛黄文件与红色火漆印章构成的调查档案静物"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-4 md:right-6 bg-primary-500 text-background-50 rounded-lg px-6 py-5 max-w-[220px]">
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-background-50/80">
                  Since 2019
                </p>
                <p className="mt-2 font-heading text-base font-bold leading-snug">
                  以不暴露信源为每一次选题的前提
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-4">
            <SectionHeading
              kicker="Who We Are"
              title="我们把散落的线索，整理成可以被验证的事实"
              description="深瞳爆料不是爆料的中转站，而是一个认真对待信息的整理者。每一条线索都会经过来源确认、关键事实交叉核对与去标识化处理，再决定是否进入公开议题。"
            />

            <div className="mt-9 space-y-5">
              {highlights.map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-9 inline-flex items-center gap-2 border border-foreground-950/20 hover:border-primary-500 hover:text-primary-600 text-foreground-900 text-sm font-medium px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              了解平台的完整内容原则
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}